<template>
  <section class="ui-card" :class="{ 'ui-card-padded': padded }">
    <slot />
  </section>
</template>

<script>
export default {
  name: 'UiCard',
  props: {
    padded: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.ui-card {
  border: 1px solid hsl(var(--border));
  border-radius: 14px;
  background: hsl(var(--card));
  color: hsl(var(--card-foreground));
}

.ui-card-padded {
  padding: 16px;
}
</style>
